export default {
  material: {
    nameMaterial: 'Material',
    itemNameCode: 'Material Code',
    segment: 'Segment',
    family: 'Family',
    Class: 'Class',
    productServiceCategory: 'Product/Service Category',
    price: 'Price stimated in USD',
    isUrgent: 'Urgent',
    replaces: 'Replace Ellipse code with',
    filterManufacturer: 'Filter by Manufacturer',
    manufacturerName: 'Manufacturer',
    acronymManufacturer: 'Acronym',
    partNumber: 'Part Number',
    uom: 'Unit Of Measure',
  },
  manufacturer1: 'Manufacturer 1',
  manufacturer2: 'Manufacturer 2',
  enableManufacturer: 'Enable manufacturer 2',
  completeManufacturer:
    'You must first complete the manufacturer 1 information',
  collaManufacturerSelected:
    'If you select the Colla manufacturer you must attach a blueprint',
  seeMore: 'See more',
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/cataloger/createNewMaterials/Stages/infGeneral.js